import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { NavigationTrackerService } from '../../services/navigation-guard/navigation-tracker.service';

/**
 * Blocks navigation when the user copy-pastes or manually edits a URL
 * in the address bar. Redirects back to the page they were on.
 */
@Injectable({
  providedIn: 'root'
})
export class PreventUrlManipulationGuard implements CanActivate, CanActivateChild {

  constructor(
    private navigationTracker: NavigationTrackerService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.check(state);
  }

  canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.check(state);
  }

  private check(state: RouterStateSnapshot): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    if (this.navigationTracker.shouldBlockNavigation(state.url)) {
      const storedRoute = this.navigationTracker.getStoredRoute();
      if (storedRoute) {
        return this.router.parseUrl(storedRoute);
      }
    }

    return true;
  }
}
